/**
 * List of apache directives to access web services
 */
export const GLH_WS = {
  glh: "ussigws"
};

/**
 * Group Life and Health web services
 */
export const GLH_URL = {
  X: GLH_WS.glh + "/wgr001.pgm"
};
